import Box from "@vapor/react-material/Box";
import CssBaseline from "@vapor/react-material/CssBaseline";
import VaporAppBar from "@vapor/react-uishell/VaporAppBar";
import VaporUIShellNav from "@vapor/react-uishell/VaporUIShellNav";

import { useIsEmbed } from "../../utils/use-is-embed";

export const DefaultLoadingView = () => {
  const { isEmbed } = useIsEmbed();
  if (isEmbed) return null;

  return (
    <Box>
      <CssBaseline />
      <VaporUIShellNav renderToolbar={<VaporAppBar />} />
    </Box>
  );
};
